import { EmployeeListItemViewModel, EmployeeModel, IcdCorporationManager } from '@herbjoy/apex-api-models';
import angular, { IFormController, IQService } from 'angular';
import { EventEmitter } from '../../common/components/event-emitter';
import { EmployeeService } from '../../core/services';
import { UtilityService } from '../../core/services/utility.service';
import templateUrl from './edit-corporation-manager.component.html';

export const EditCorporationManagerComponent = {
    templateUrl,
    bindings: {
        roleName: "<",
        roleID: "<",
        manager: "<",
        // Must be a generic service function that returns a promise
        // resolving to an IcdCorporationManager interface.
        saveManager: "&onSaveManager"
    },
    controllerAs: "vm",
    controller: class EditCorporationManagerController {
        //@Input
        manager: IcdCorporationManager;
        //@Input
        roleName: string;
        //@Input
        roleID: number;
        //@Input
        saveManager: EventEmitter<{ manager: IcdCorporationManager }>
        pristineManager: IcdCorporationManager;
        editForm: IFormController;
        employees: EmployeeListItemViewModel[];
        loaded = false;
        constructor(private $q: IQService, private employeeService: EmployeeService,
            private utilityService: UtilityService) {
            'ngInject';
        }

        $onChanges(changesObj) {
            if (changesObj.manager && this.editForm) {
                // Reset the form if the manager object was replaced.
                this.editForm.$setPristine();
            }

            this.utilityService.showLoading();

            // Get the manager instance.
            const loadManager = this.$q.resolve(this.manager);

            // Get the instance of the manager's selected employee, in case it is no longer in the list.
            const loadSelectedEmployee = loadManager.then<EmployeeModel>(manager => {
                if (!manager.EmployeeID) {
                    return null;
                }
                return this.employeeService.retrieveEmployee(manager.EmployeeID)
            })
                .catch<EmployeeModel>(function (ex) {
                    // Employee is no longer on the site, so unassign the employee ID.
                    return null;
                });

            // Load the list of all employees with the given role.
            //HACK: Auditors have a slightly different role name from the one used in services.
            const loadManagerEmployees = this.employeeService.retrieveEmployees({ RoleID: this.roleID });

            // Get all employees that should be displayed in the list on the page.
            const loadEmployees = this.$q.all([loadSelectedEmployee, loadManagerEmployees])
                .then(([selectedEmployee, managerEmployees]) => {
                    return this.mergeListAndSelection(managerEmployees, selectedEmployee);
                })
                .then(function (employees) {
                    // Add text property to the employee.
                    for (let i = 0; i < employees.length; i++) {
                        const employee = employees[i];
                        employee.Text = employee.FirstName + " " + employee.LastName + " (" + employee.EmailAddress + ")";
                    }
                    return employees;
                });

            // Once the manager data and employee list data is loaded, hide the loading animation.
            this.$q.all([loadManager, loadEmployees])
                .then(v => {
                    this.manager = v[0];
                    this.pristineManager = angular.copy(this.manager);
                    this.employees = v[1];
                })
                .catch(function (ex) {
                    alert("Initial load failed: " + (ex.message || (ex.statusText !== undefined ? ex.statusText : ex)));
                })
                .then(() => {
                    this.utilityService.hideLoading();
                });
        }

        handleCancelClick() {
            this.manager = angular.copy(this.pristineManager);
            this.editForm.$setPristine();
        }

        handleSubmit() {
            this.saveManager({ $event: { manager: this.manager } });
        }

        /**
         * Add the selected item to the list if the list does not contain a item with the same id value.
         * @param list The list of items that the selection should be merged into.
         * @param selection The selected item that should be merged into the list.
         * @param idSelector A selector function that returns a list item's property that can be used for value comparison.
         * TODO: Add to general utilities.
         */
        private mergeListAndSelection(list, selection, idSelector?) {
            if (!idSelector) {
                idSelector = function (item) {
                    return item.Id;
                };
            }
            if (selection && !list.filter(function (item) {
                return idSelector(item) === idSelector(selection)
            })[0]) {
                // The item was previously selected, but it is not in the current list,
                // so add it to the front of the list.
                list.unshift(selection);
            }
            return list;
        }
    }
};
